export default {
    tableData: []
}